import React, { useState } from "react";
import PropTypes from "prop-types";
import ResultsWrappers from "../modals/ResultsWrapper";
import UserPreview from "../modals/UserPreview";
import useSkillset from "../customHooks/useSkillset";
import Rating from "@mui/material/Rating";
import NextRouter from "next/router";
import { Typography, Avatar } from "@mui/material";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  buttonUser: {
    fontSize: "18px",
    fontWeight: 700,
    padding: "0.5rem 1rem",
  },

  image_search_avatar: {
    height: "78px",
    width: "78px",
    borderRadius: "50%",
    marginRight: "10px",
  },

  container_user_card_top: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },

  name_title: {
    fontFamily: "Poppins",
    fontSize: "17.5px",
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",
    display: "block",
    margin: 0,
  },


});

const UserFound = ({ userObj, skill }) => {
  const classes = useStyles();
  // State
  const [showPreview, setShowPreview] = useState(false);
  // const [canInvite, setCanInvite] = useState(false);

  let picture = userObj.picture;
  if (picture === null || (picture.includes("https://avatars.dicebear.com/api/bottts/") && picture.includes("svg?colors[]=teal&primaryColorLevel=400") || picture === "http://res.cloudinary.com/teammateme-com/image/upload/v1712259855/UserAvatar/x7kgrpnhq7vx5yze7krx.svg")) {
    picture = `https://api.dicebear.com/9.x/icons/svg`;
  }

  const toggleUserPreview = () => {
    setShowPreview(!showPreview);
  };

  const { Ratings, Skills } = userObj;

  const totalRating =
      (Ratings.reduce(
          (total, rating) => parseFloat(total) + parseFloat(rating.skillset_rating),
          0
      ) / Ratings.length).toFixed(1) || 0;

  //? This logic was part of inviting users to a team from this component.
  // This context comes from the GlobalContext Wrapper Component
  // const appState = useContext(GlobalContext);
  // const { currentUser } = appState;

  // useEffect(() => {
  //   if (currentUser !== undefined) {
  //     setCanInvite(true);
  //   }
  // }, [currentUser]);

  // Build skillset string
  const skillsetStr = useSkillset(userObj.Skills);

  const skillElement = (
    <h4 className="header header--user_card_skill">
      {skill === undefined ? (
        <div className="skills-wrapper">
          {userObj.Skills.length > 0 ? (
            <div className="animation-wrapper">
              {Skills.map((skillName, index) => (
                <div key={index} className="user-skill">
                  {` ${skillName.skill} `}
                </div>
              ))}
            </div>
          ) : (
            <div>{skillsetStr}</div>
          )}
        </div>
      ) : (
        skill
      )}
    </h4>
  );

  const goToPublicUserPage = () => {
    // Move to public user page
    setTimeout(() => {
      NextRouter.push(`/user/${userObj.public_user_id}`);
    }, 750);
  };

  return (
    <>
      {showPreview && (
        <ResultsWrappers togglePreview={toggleUserPreview}>
          <UserPreview
            userInfo={userObj}
            togglePreview={toggleUserPreview}
            skillStr={skill}
          />
        </ResultsWrappers>
      )}
      <div className="button--result_wrapper">
        <div className="container--user_display">
          {/* <div className="container--user_card_top">
            <img
              className="image image--search_avatar"
              src={userObj.picture}
              alt="Avatar"
            />
            <h3 className="header header--user_card_name">
              <Typography className={classes.name_title}>
                {userObj.fullname}
              </Typography>
            </h3>
          </div> */}
          <div className={classes.container_user_card_top}>
            <Avatar
              className={classes.image_search_avatar}
              src={picture}
              alt="Avatar"
              style={{ backgroundColor: "#00B790" }}
            >
              {userObj.fullname[0]}
            </Avatar>
            <Typography className={classes.name_title}>
              {userObj.fullname}
            </Typography>
          </div>
          <hr className="hr--dashboard_page_break" />
          <div className="container--user_card_bottom">
            <div className="user_rating_data">
              <span className="user_rating_data_name">Skills:</span>
              <span className="review_unspecified">{skillElement}</span>
            </div>
            <div className="user_rating_review">
              <span className="user_rating_data_name">Reviews:</span>
              {totalRating && !isNaN(totalRating) ? (
                <div className="review_rating_star">
                  <Rating
                    value={totalRating}
                    precision={.5}
                    readOnly
                    max={5}
                    className="user_rating_found"
                  />
                  <span className="user_total_rating">{totalRating}</span>
                </div>
              ) : (
                <div className="review_unspecified">No ratings yet...</div>
              )}
            </div>
          </div>
          <div style={{display: "flex", textAlign: "center", alignSelf: "flex-end", justifyContent: "center"}}>
            <button
              className="user-card-message_me_button"
              type="button"
              onClick={goToPublicUserPage}
              aria-label="View Profile"
            >
              View Profile
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserFound;

UserFound.propTypes = {
  userObj: PropTypes.object,
  skill: PropTypes.string,
};
